import {Component, Input} from '@angular/core';
import {CommonModule} from '@angular/common';
import {LinkBlock} from "./types/link-block";
import {Router, RouterLink} from "@angular/router";
import {environment} from 'src/environments/environment';
import {WebpImageComponent} from "../../../components/webp-image/webp-image.component";

@Component({
  selector: 'app-widget-link-block',
  standalone: true,
  imports: [CommonModule, RouterLink, WebpImageComponent],
  templateUrl: './link-block.component.html',
  styleUrls: ['./link-block.component.less']
})
export class LinkBlockComponent {
  @Input() widget!: LinkBlock;

  public constructor(
    private router: Router,
  ) {
  }

  public getImageUrl(): string {
    return `${environment.cdn.url}/cdn/thumbnails/media/${this.widget.data.image}`;
  }

  public getUrl(): undefined | string {
    if (this.widget.data.fileUrl) {
      return this.getFileUrl();
    }

    return this.widget.data.url;
  }

  public getFileUrl(): string {
    return `${environment.cdn.url}/cdn/${this.widget.data.fileUrl}`;
  }

  public getClasses(): string[] {
    return [
      `text-${this.widget.data.textAlign ?? 'center'}`
    ]
  }

  public isExternalUrl(): boolean {
    return this.widget.data.url ? this.widget.data.url.startsWith('http') : false;
  }

  public getAltText(): string {
    return this.widget.data.tooltip ?? this.widget.data.title.replace(/<[^>]*>/g, '');
  }
}
